import M from 'moment';
import LinkTitleComponent from '72cms-ui/components/table-elements/LinkTitleComponent';
import OrderCustomerComponent from '72cms-ui/components/table-elements/OrderCustomerComponent';
import DateTimeComponent from '72cms-ui/components/table-elements/DateTimeComponent';
import CustomFilterComponent from '72cms-ui/components/helpers/CustomFilterComponent';
import RangeFilterComponent from '72cms-ui/components/helpers/RangeFilterComponent';
import ActiveSwitchActionComponent from '72cms-ui/components/table-elements/ActiveSwitchActionComponent';

export default {
    fields: {
        created_at: {
            label: 'Date',
            component: {
                template: `<a class="text-normal" :href="'#/order/' + data.id">{{ __(initialValue, ['datetime']) }}</a>`,
                props: ['initialValue', 'data'],
            }
        },
        order_type: {
            label: 'Type',
            component: {
                template: `<a class="text-bold title-link" :href="'#/order/' + data.id">{{ initialValue }}</a>`,
                props: ['initialValue', 'data'],
            },
        },
        fullname: {
            label: 'Customer',
        },
        latest_status: {
            component: {
                template: `<span :class="['badge', flavor]">{{ initialValue }}</span>`,
                props: ['initialValue'],
                computed: {
                    flavor() {
                        switch (this.initialValue) {
                            case 'New Order': return 'badge-primary';
                            case 'Processing': return 'badge-success';
                            case 'Shipped': return 'badge-warning';
                            case 'Cancelled': return 'badge-danger';
                            case 'Credit': return 'badge-primary';
                            default: return 'badge-default';
                        }
                    }
                }
            }
        },

    },
    sortable: ['id', 'order_date', 'firstname', 'order_type'],
    filterable: [],
    customFilters: [],
    pagination: false,
    searchable: false,
    hierarchy: false,
    batchActions: ['delete'],
    actions: [
        {
            name: 'delete',
            component: 'delete-button',
            primary: true,
        },
    ]
}



// WEBPACK FOOTER //
// ./resources/assets/cms/js/config/collection.customer-orders.js